module.exports = __webpack_public_path__ + "img/lock.ebe90a00.gif";